import { useState, useEffect, useRef } from "react";

export default function useExpander(defaultOpen) {
    const ref = useRef(null);
    const [open, setOpen] = useState(defaultOpen);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (open && ref.current) {
            setHeight(ref.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [open, ref]);

    useEffect(() => {
        setOpen(defaultOpen);
    }, [defaultOpen]);

    return { open, setOpen, height, ref };
}

